import React from "react";
import ReactDOM from "react-dom/client"; // React 18+
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Dynamically load Google Maps API
const loadGoogleMapsAPI = () => {
  if (!window.google) {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAIyY4C-OPivpAncytCELY-fUCk9aJsDWc&libraries=places&callback=initGoogleMaps";
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      console.error("Failed to load Google Maps API.");
    };
    document.head.appendChild(script);
  }
};

// Initialize the app after Google Maps API loads
window.initGoogleMaps = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Load Google Maps API
loadGoogleMapsAPI();

// //Register the Firebase service worker
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Service Worker registered successfully:", registration);
//       return registration;
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }


serviceWorkerRegistration.register();
